import styled, { css, FlattenSimpleInterpolation } from "styled-components";
import { FC } from "react";
import { BaseComponentProps } from "../types";
import { BaseIcon } from "./BaseIcon";
import { SizedIcon } from "./SizedIcon";
import { IconName, IconSize, WhiteIconVariant } from "./types";
import "../../designTokens/variables.css";

type StyledWhiteIconProps = {
  $variant: WhiteIconVariant;
  $plain?: boolean;
};

const StyledWhiteIcon = styled(SizedIcon)<StyledWhiteIconProps>`
  ${({ $variant, $plain }): FlattenSimpleInterpolation => {
    switch ($variant) {
      case "INACTIVE":
        return css`
          svg {
            --main-color: var(--color-neutral-000-inactive);
          }
        `;
      case "DISABLED":
        return css`
          svg {
            --main-color: var(--color-primary-200);
          }
        `;
      case "DEFAULT":
      default:
        return $plain
          ? css`
              svg {
                --main-color: var(--color-neutral-000-full);
              }
            `
          : css`
              svg {
                --main-color: var(--color-neutral-000-full);
                :hover {
                  --main-color: var(--color-secondary-600);
                }
              }
            `;
    }
  }};
`;

type WhiteIconProps = BaseComponentProps<
  "svg",
  {
    /** The icon that will be rendered. */
    iconName: IconName;

    /** The size of icon that will be rendered. */
    iconSize?: IconSize;

    /** The type of icon that will be rendered. */
    variant?: WhiteIconVariant;

    /** This variable disables the hover effect on default. */
    plain?: boolean;
  }
>;

export const WhiteIcon: FC<WhiteIconProps> = ({
  iconSize = "regular",
  variant = "DEFAULT",
  plain = false,
  className,
  ...props
}) => (
  <StyledWhiteIcon
    className={className}
    $variant={variant}
    $iconSize={iconSize}
    $plain={plain}
  >
    <BaseIcon disabled={variant === "DISABLED"} {...props} />
  </StyledWhiteIcon>
);

// TODO: Remove this component as soon as possible. Use the prop `iconSize` instead.

export const SmallWhiteIcon: FC<WhiteIconProps> = ({
  iconSize = "small",
  variant = "DEFAULT",
  plain = false,
  className,
  ...props
}) => (
  <StyledWhiteIcon
    className={className}
    $variant={variant}
    $iconSize={iconSize}
    $plain={plain}
  >
    <BaseIcon disabled={variant === "DISABLED"} {...props} />
  </StyledWhiteIcon>
);
